<ion-content [ngClass]="contentClasses">
  <div class="loading-container" [ngClass]="{'platform-core': isDesktop, 'platform-mobile': !isDesktop}">
    <img
      alt=""
      class="logo"
      [src]="'assets/global/img/' + (!globalVars.FEATURES?.MSO_NewReBranding ? 'logo' : (isCasinoPage ? 'logo-purple' : 'logo-green')) + '.svg'"
      *ngIf="globalVars.licenseType !== 4"
    />
    <img alt="" class="logo" src="assets/global/img/codere-apuestas-mx.svg" *ngIf="globalVars.licenseType === 4" />
    <ng-lottie class="loadingSplash" [ngClass]="{'greenFilter': !isCasinoPage}" [options]="options"></ng-lottie>

    <h3 *ngIf="globalVars.FEATURES?.MSO_NewReBranding">{{ 'textLoading'| translate}}</h3>
  </div>
</ion-content>
